import { createUserManager } from 'redux-oidc';

const UserManagerConfig = {
    client_id: '84d99950-1ffc-47b8-bd4d-2c586a608134', //ACN Staging
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/userlogin`,
    response_type: 'token',
    scope: '68ee728b-f781-4f1b-ac4b-bc628e0c0ea9/user.impersonation.scope',
    authority: 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22/v2.0/.well-known/openid-configuration',
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silentrenew`,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: false,
    revokeAccessTokenOnSignout: true,
    silentRequestTimeout: 100000,
    accessTokenExpiringNotificationTime: 300
};

const _UserManager = createUserManager(UserManagerConfig);

export default _UserManager;
